import { render } from "./HomeChannel.vue?vue&type=template&id=73096c51&scoped=true"
import script from "./HomeChannel.vue?vue&type=script&lang=js"
export * from "./HomeChannel.vue?vue&type=script&lang=js"

import "./HomeChannel.vue?vue&type=style&index=0&id=73096c51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73096c51"]])

export default __exports__